// extracted by mini-css-extract-plugin
export default {"carouselContainer":"RevolvingLogoComponent_carouselContainer__a3UGz","carouselTrack":"RevolvingLogoComponent_carouselTrack__6BJwi","slide":"RevolvingLogoComponent_slide__nJoym"};